import {
    GET_ALL_LEADS,GET_LEAD_DETAILS,GET_LEAD_FILTERS,UPDATE_LEAD_STATUS,UPDATE_LEAD_ACCOUNT,CREATE_NEW_LEAD,FETCH_CUSTOMER_DETAILS
} from './type';

const initialState = {
    allLeads:[],
    leadDetails:[],
    leadFilters:[],
    leadUpdated:[],
    leadAccount:[],
    newLead:[],
    getCustomerDetailsUsingPan: []
};

const LeadManagement = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case GET_ALL_LEADS:
            return {
                ...state,
                allLeads: payload,
            };
        case GET_LEAD_DETAILS:
            return {
                ...state,
                leadDetails: payload,
            };
        case GET_LEAD_FILTERS:
            return {
                ...state,
                leadFilters:payload,
            }
        case UPDATE_LEAD_STATUS:
            return {
                ...state,
                leadUpdated:payload,
            }
        case UPDATE_LEAD_ACCOUNT:
            return{
                ...state,
                leadAccount: payload,
            }
        case CREATE_NEW_LEAD:
            return {
                ...state,
                newLead:payload,
            }
        case FETCH_CUSTOMER_DETAILS:
            return {
                ...state,
                getCustomerDetailsUsingPan:payload,
            }
        default:
            return {...state};
    }
};


export default LeadManagement;